export {
  AboutCardSecondaryBenefit,
  Component,
} from './AboutCardSecondaryBenefit';
